<template>
  <div class="bg-FFFFFF" :class="{ bb: showBorder }">
    <template v-if="!isCustomNotification">
      <div class="fb fb-main-between">
        <div
          class="fb fb-main-between fb-cross-center font-28 h-48 p-14-0 p-0-16 bb width-full item-flex-1 hidden-x"
        >
          <!-- 切换日期 -->
          <span class="item-shrink-0" @click="handlerToSelectDate"
            >{{ showDate
            }}<i class="iconfont c-171A1D font-24 pl-6">&#xe648;</i></span
          >
          <!-- 筛选 -->
          <span
            :class="[computedQueryFilterText ? 'c-006AFE ' : '']"
            v-if="pageType !== 'classDept' || computedQueryFilterText"
            @click="handlerJumpFilterPage"
          >
            <i
              class="iconfont mr-4"
              :class="[computedQueryFilterText ? 'c-006AFE ' : '']"
              >&#xe6f4;</i
            >筛选
          </span>
          <!-- 切换年级 -->
          <div
            v-else
            class="item-shrink-0 item-flex-1 c-171A1D font-28 text-right fb fb-cross-center fb-main-end w-adapt-100"
            @click="handlerChangeClass"
          >
            <span class="text-ellipsis inline-block w-adapt-24">
              {{ computedDeptName }}</span
            ><i
              class="iconfont font-24 c-171A1D ml-4"
              v-if="!isHeadmaster || (classList || []).length > 1"
              >&#xe648;</i
            >
          </div>
        </div>
        <!-- 报表 -->
        <div
          class="c-171A1D font-28 text-right fb fb-cross-center fb-main-end pr-16"
          v-if="showToReports"
        >
          <span @click="handlerJumpReportsPage">
            <i class="iconfont mr-4 font-34">&#xe6a9;</i>报表
          </span>
        </div>
      </div>
      <!-- 班主任且存在多个班级 -->
      <div
        class="fb fb-main-between fb-cross-center font-28 pt-12 pb-12 p-0-16 c-171A1D"
        v-if="isHeadmaster && (classList || []).length > 1"
      >
        <span class="mr-16" @click="handlerChangeClass"
          >{{ computedDeptName
          }}<i
            class="iconfont c-171A1D font-24 ml-4"
            v-show="(classList || []).length > 1"
            >&#xe648;</i
          ></span
        >
      </div>
    </template>

    <!-- 筛选条件 -->
    <div
      class="fb fb-main-between fb-cross-center font-28 p-8-0 p-0-16 c-171A1D"
      v-if="queryFilter"
    >
      <span class="mr-20">{{ computedQueryFilterText }}</span>
      <i
        class="iconfont"
        v-if="!isCustomNotification"
        @click="handlerClearQueryFilter"
        >&#xe670;</i
      >
    </div>
    <div
      class="bg-F6F6F6 ml-16 mr-16 font-30 bd-radio-8 text-center mb-34 p-0-5 p-5-0 h-48 fb fb-main-between fb-cross-center"
    >
      <p
        @click="choose(item.id)"
        v-for="(item, index) in inOutTypeList"
        :key="`inout${index}`"
        class="lh-38 item-flex-1 ff-medium bd-radio-6"
        :class="{ 'mr-5': index === 0, 'bg-FFFFFF': inOutType === item.id }"
        >{{ item.name }}</p
      >
    </div>
  </div>
</template>

<script>
import { timeFormat } from '@/utils/comUtils'
import { WEEK_DAY, IN_OUT_TYPE } from '@/utils/constUtils'

export default {
  name: 'commonDateSelectNew',
  props: {
    value: String,
    isHeadmaster: {
      type: Boolean,
      default: false
    },
    dingDeptIds: {
      type: [String, Number],
      default: ''
    },
    dateOnly: {
      type: Boolean,
      default: false
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    classList: {
      type: Array,
      default: null
    },
    pageType: {
      type: String,
      default: 'index'
    },
    dingDeptName: {
      type: String,
      default: ''
    },
    showToReports: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      IN_OUT_TYPE: IN_OUT_TYPE,
      date: '',
      week: '',
      inOutType: 1,
      inOutTypeList: [
        {
          id: 1,
          name: '上学'
        },
        {
          id: 2,
          name: '下学'
        }
      ],
      showAction: false
    }
  },
  computed: {
    isCustomNotification() {
      return this.$store.getters.isCustomNotification
    },
    queryFilter() {
      return this.$store.getters.attendanceQueryFilter || null
    },
    computedIsWholeSchool() {
      return this.$store.getters.isWholeSchool
    },
    computedQueryFilterText() {
      return this.isHeadmaster
        ? this.$store.getters.storeGettersFilterText.replace('全校、', '')
        : this.$store.getters.storeGettersFilterText
    },
    showDate() {
      if (!this.date) {
        return ''
      }
      let _showDate = ''
      let _date = this.date.replace(/-/gi, '.')
      let _now = timeFormat(new Date(), 'YYYY.MM.DD')
      if (_date === _now) {
        _showDate = '今天'
      } else {
        _date = _date.slice(5, 10)
        _showDate = `${_date} ${this.week}`
      }
      return _showDate
    },
    computedDeptName() {
      let dept = this.$store.getters.attendanceMainDept || {}
      return dept.name || '请选择'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.init()
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerChangeClass() {
      this.$emit('handlerChangeClass')
    },
    init() {
      // 初始化月统计日期
      this.$store.commit('monthTime', null)
      this.methodUpdateDate(this.value)
      this.$emit('handlerIsResetFilter')
      this.$store.commit('attendanceMainDate', this.date)
      let _time = timeFormat(new Date(), 'hhmm')
      setTimeout(() => {
        this.inOutType =
          this.$store.getters.inOutType || (+_time > 1200 ? 2 : 1)
      }, 0)
    },
    // 选择日期
    handlerToSelectDate() {
      this.$emit('date-click')
    },
    methodUpdateDate(date) {
      let _date = date ? new Date(date) : new Date()
      this.date = timeFormat(_date, 'YYYY-MM-DD')
      this.week = WEEK_DAY[_date.getDay()]
    },
    monthTotal() {
      let query = {
        date: this.date
      }
      if (this.isHeadmaster && this.dingDeptIds) {
        query.dingDeptIds = this.dingDeptIds
      }
      this.$router.push({
        path: '/attendance/pageAttendanceMonth',
        query: query
      })
    },
    choose(id) {
      this.inOutType = id
      this.$store.commit('inOutType', this.inOutType)
      this.$parent.fetchAttendanceStatusByClass()
      // this.showAction = false
    },
    // 选择上下学
    handlerSelectInOutType() {
      this.showAction = true
    },
    close(show) {
      this.showAction = show
    },
    // 跳转到筛选页面
    handlerJumpFilterPage() {
      this.$store.commit('attendanceMainDept', null)
      this.$router.push({
        path: '/attendance/filter',
        query: {
          isHeadmaster: this.isHeadmaster ? 1 : ''
        }
      })
    },
    handlerClearQueryFilter() {
      let prevDate = this.date
      this.$store.commit('setAttendanceQueryFilter', null)
      this.$store.commit('setAttendanceSelectDetailNodes', null)
      this.methodUpdateDate()
      let nextDate = this.date
      if (prevDate === nextDate) {
        this.$parent.initResetPage(true)
      } else {
        this.$emit('input', this.date)
      }
      // 重置操作 attendanceDetailComponents
      this.$emit('updateAttendanceDetail')
    },
    handlerJumpReportsPage() {
      this.$emit('handlerJumpReportsPage')
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.month-statics {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 13px;
}
.filter-condition {
  display: flex;
  align-items: center;
  &-clear {
    flex-basis: 32px;
    vertical-align: middle;
    text-align: center;
  }
}
</style>
